import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
  FormControl,
  Select,
} from '@chakra-ui/react'
import { useMutation, useQuery } from 'react-query'
import { api, baseURL } from '../../../services/api'
import { useForm } from 'react-hook-form'
import InputFloating from '../../../components/InputFloating'
import { useEffect } from 'react'
import { listarCoresDisponiveis } from '../requests'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const schema = yup.object().shape({
  codigoProduto: yup.string().required('Campo obrigatório'),
  quantidade: yup.string().required('Campo obrigatório'),
  valorUnitario: yup
    .string()
    .required('Campo obrigatório')
    .transform((value) => {
      return value.replace(',', '.')
    }),
  valorTotal: yup.number().required('Campo obrigatório'),
  id_impressao: yup.string().required('Campo obrigatório'),
  cor: yup.string().required('Campo obrigatório'),
  quantidadeBatida: yup.string().required('Campo obrigatório'),
  prazoEntrega: yup.string().required('Campo obrigatório'),
  cubagemUnitaria: yup.string().required('Campo obrigatório'),
  cubagemTotal: yup.string().required('Campo obrigatório'),
  quantidadeCaixa: yup.string().required('Campo obrigatório'),
  quantidadePorCaixa: yup.string().required('Campo obrigatório'),
})

async function createItem(params) {
  const response = await api.post(
    '/site/v2/editar-pedido/inserir-produto-pedido',
    params
  )

  return response.data
}

export function AdicionarItem({ item, enterprise, refetch }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { handleSubmit, register, watch, setValue, formState, reset } = useForm(
    {
      resolver: yupResolver(schema),
    }
  )

  const quantidade = watch('quantidade')
  const valorUnitario = watch('valorUnitario')?.replace(',', '.')

  useEffect(() => {
    if (!quantidade || !valorUnitario) return

    const valorTotal = quantidade * valorUnitario

    setValue('valorTotal', valorTotal)
  }, [quantidade, valorUnitario, setValue])

  console.log({
    item,
    enterprise,
  })

  const { data: gravacoes } = useQuery({
    queryFn: async () => {
      const { data } = await baseURL.get(
        `/detalhes-produto/lista-impressoes-gerais/${item?.CODPROD}`
      )
      return {
        gravacoes: data,
      }
    },
    queryKey: ['get-info-selects-inp', item?.CODPROD],
    refetchOnWindowFocus: false,
  })

  const { data: cores } = useQuery({
    queryFn: async () => {
      const cores = await listarCoresDisponiveis(item?.CODPROD)
      return {
        cores,
      }
    },
    queryKey: ['get-info-selects', item?.CODPROD],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 3,
  })

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
    duration: 3000,
  })

  const optionsEntrega = Array.from({ length: 10 }).map((_, index) => {
    return {
      value: index + 1,
      label: `${index + 1} dias`,
    }
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: createItem,
    onSuccess: () => {
      refetch()
      onClose()
      reset()
      toast({
        title: 'Item adicionado com sucesso',
        status: 'success',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao adicionar item',
        status: 'error',
      })
    },
  })

  async function handleCreateItem(data) {
    const params = {
      codigo_vendedor: enterprise?.codigo_vendedor,
      codigo_empresa: enterprise?.codigo_empresa,
      id_impressao: data?.id_impressao,
      codigo_produto: data?.codigoProduto,
      quantidade: data?.quantidade,
      valor_unitario: data?.valorUnitario,
      valor_total: data?.valorTotal,
      quantidade_batida: data?.quantidadeBatida,
      id_cor: data?.cor,
      prazo_entrega: data?.prazoEntrega,
      cubagem_total: data?.cubagemTotal,
      cubagem_unitaria: data?.cubagemUnitaria,
      quantidade_caixa: data?.quantidadeCaixa,
      quantidade_por_caixa: data?.quantidadePorCaixa,
      numero_nota: item?.NUNOTA,
    }

    try {
      console.log(params)
      await mutateAsync(params)
    } catch (error) {
      console.log(error)
    }
  }

  console.log(gravacoes)

  return (
    <>
      <Button
        bg="#7FBC03"
        color="white"
        _hover={{
          filter: 'brightness(0.9)',
        }}
        variant="outline"
        onClick={onOpen}
        alignSelf="flex-end"
        justifySelf="flex-end"
        mt="1rem"
      >
        Adicionar item
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(handleCreateItem)}>
          <ModalHeader>Adicionar um novo item</ModalHeader>
          <ModalCloseButton />
          <ModalBody
            as={FormControl}
            display="grid"
            gridTemplateColumns="1fr 1fr"
            gridGap="1rem"
          >
            <InputFloating
              label="Codigo do produto"
              bgColor="transparent"
              {...register('codigoProduto')}
              error={formState.errors?.codigoProduto}
            />
            <InputFloating
              label="Quantidade"
              bgColor="transparent"
              {...register('quantidade')}
              error={formState.errors?.quantidade}
            />
            <InputFloating
              label="Valor unitário"
              bgColor="transparent"
              {...register('valorUnitario')}
              error={formState.errors?.valorUnitario}
            />
            <InputFloating
              label="Valor total"
              bgColor="transparent"
              {...register('valorTotal')}
              disabled
            />
            <Select
              id="gravacao"
              placeholder="Gravação"
              {...register('id_impressao')}
              error={formState.errors?.id_impressao}
            >
              {gravacoes?.gravacoes?.map((gravacao, index) => (
                <option key={index} value={gravacao.codigo_impressao}>
                  {gravacao.descricao_impressao}
                </option>
              ))}
            </Select>
            <Select
              id="cor"
              placeholder="Cor"
              {...register('cor')}
              error={formState.errors?.cor}
            >
              {cores?.cores?.map((cor) => (
                <option key={cor.codigo_cor} value={cor.codigo_cor}>
                  {cor.descricao_cor}
                </option>
              ))}
            </Select>
            <InputFloating
              label="Quantidade batida"
              bgColor="transparent"
              {...register('quantidadeBatida')}
              error={formState.errors?.quantidadeBatida}
            />
            <Select
              id="prazo"
              placeholder="Prazo entrega"
              {...register('prazoEntrega')}
              error={formState.errors?.prazoEntrega}
            >
              {optionsEntrega.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
            <InputFloating
              label="Cubagem unitária"
              bgColor="transparent"
              {...register('cubagemUnitaria')}
              error={formState.errors?.cubagemUnitaria}
            />
            <InputFloating
              label="Cubagem total"
              bgColor="transparent"
              {...register('cubagemTotal')}
              error={formState.errors?.cubagemTotal}
            />
            <InputFloating
              label="Quantidade de caixa"
              bgColor="transparent"
              {...register('quantidadeCaixa')}
              error={formState.errors?.quantidadeCaixa}
            />
            <InputFloating
              label="Quantidade por caixa"
              bgColor="transparent"
              {...register('quantidadePorCaixa')}
              error={formState.errors?.quantidadePorCaixa}
            />
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button colorScheme="green" type="submit" isLoading={isLoading}>
              Cadastrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
